import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableServerQuery,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { capitalize } from 'lodash';

interface getDynamicFormsDataTableStructureProps {
  rowActions?: DataTableRowActions;
  createAction?: () => void;
  serverQuery?: DataTableServerQuery;
}

export const getDynamicDocumentsDataTableStructure = ({
  rowActions,
  createAction,
  serverQuery,
}: getDynamicFormsDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'transanctionalForm.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };

  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'transanctionalForm.table.name',
    accessorKey: 'name',
    variant: DataTableColumnVariant.TEXT,
  };

  const orderColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'transanctionalForm.table.order',
    accessorKey: 'order',
    variant: DataTableColumnVariant.TEXT,
  };

  const folderTypeColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'transanctionalForm.table.typeDossier',
    accessorKey: 'typeDossier.libelle',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return { value: capitalize(value) };
    },
    props: {
      getSeverity: (value: string) => {
        return value === 'ADMINISTRATIVE' ? 'info' : value === 'TECHNIQUE' ? 'warn' : 'primary';
      },
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'transanctionalForm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: value => {
      return { value: value == 'ACTIF' ? 'transanctionalForm.form.active' : 'transanctionalForm.form.inActive' };
    },
    props: {
      getSeverity: value => {
        return value == 'ACTIF' ? 'success' : 'danger';
      },
    },
  };

  const formTypeColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'transanctionalForm.table.formType',
    accessorKey: 'formType',
    variant: DataTableColumnVariant.BADGE,
    renderAs: value => {
      return { value: capitalize(value) };
    },
    props: {
      getSeverity: (value: string) => {
        return value === 'TABLE' ? 'success' : value === 'FORM' ? 'info' : 'primary';
      },
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'transanctionalForm.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'transanctionalForm.table.updatedAt',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'transanctionalForm.singular',
    plural: 'transanctionalForm.plural',
    columns: [idColumn, nameColumn, orderColumn, formTypeColumn, folderTypeColumn, statusColumn, createdAtColumn, updatedAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    rowActions,
    searchableFields: ['name', 'typeDossier', 'status'],
    enableServerActions: !!serverQuery,
    serverQuery,
  };
};
